/*
 * @version: V1.0.0
 * @Date: 2023-11-02 18:00:37
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-05 17:13:17
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\warehouse\index.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 查询仓库列表
export function getWareHouse(params) {
  return request({
    url: '/wms/warehouse/list',
    method: 'get',
    params
  })
}

// 获取仓库库存列表
export function getWareHouseStock(params) {
  return request({
    url: '/wms/warehouse/listStock',
    method: 'get',
    params
  })
}
// 更新仓库
export function addWarehouse(data) {
  return request({
    url: '/wms/warehouse',
    method: 'post',
    data
  })
}

// 更新仓库
export function updateWarehouse(data) {
  return request({
    url: '/wms/warehouse',
    method: 'put',
    data
  })
}

// 删除仓库
export function deleteWarehouse(ids) {
  return request({
    url: `/wms/warehouse/${ids}`,
    method: 'delete',
  })
}
